import netteAjaxSetup from './parts/nette-ajax-setup';
import searchcontrolRichboxes from './parts/searchcontrol-richboxes';
import newsletterSettings from './parts/newsletter-settings.js';

/**
 * this function can be run only once!
 */
export default function () {
	netteAjaxSetup();
	searchcontrolRichboxes();
	newsletterSettings();
}
